import refreshCaptcha from "../utils/captcha-refresh";

const formElem = document.querySelector('.searchPostalCodes__form');
const tableElem = document.querySelector('.searchPostalCodes__table');

let paginateOptions = {
    numberPerPage: 20,
    goBar: false,
    pageCounter: false,
};


if (typeof (tableElem) != 'undefined' && tableElem != null) {
    paginate.init('.searchPostalCodes__table', paginateOptions);
}

jQuery(document).ready(function ($) {

    const selectVoivodeship = document.querySelector('#selectVoivodeship');
    const selectDistrict = document.querySelector('#selectDistrict');
    const selectCommune = document.querySelector('#selectCommune');
    const urlPage = new URL (document.URL);

    const selectVoivodeshipPreloader = document.querySelector('#selectVoivodeshipPreloader');
    const selectDistrictPreloader = document.querySelector('#selectDistrictPreloader');
    const selectCommunePreloader = document.querySelector('#selectCommunePreloader');

    refreshCaptcha('.searchPostalCodes__captcha-refresh', '#searchPostalCodes__captcha-img');

    selectVoivodeship?.addEventListener("change", (e)=>{
        selectDistrictReset();
        selectCommuneReset();

        if(""===e.target.value) {
            return;
        }

        let xhr = new XMLHttpRequest();
        let url = urlPage.origin + "/wp-content/themes/pp/inc/pna-form/pna-search-district.php";

        let data = new FormData();
        //data.append('district',e.target.value);
        data.append('province',e.target.value);
        xhr.open("POST", url, true);
        xhr.send(data);
        selectDistrictPreloader.style.display = 'flex';


        xhr.onload = () => {
            if (xhr.status !== 200) {
                console.log(`Error ${xhr.status}: ${xhr.statusText}`);
            } else {
                let res;
                res = JSON.parse(xhr.response);

                res.forEach((item,index) => {
                    let myOption;
                    myOption = document.createElement("option");
                    myOption.text = item.name;
                    myOption.value = item.value;
                    myOption.label = item.name;
                    selectDistrict.appendChild(myOption);
                });

            }
            selectDistrictPreloader.style.display = 'none';
        }

        xhr.onerror = () => console.log("Request failed");

    });

    function selectDistrictReset() {
        selectDistrict.value = null;

        while (selectDistrict.options.length > 0) {
            selectDistrict.remove(0);
        }

        let myOption;
        myOption = document.createElement("option");
        myOption.text = 'Wybierz powiat';
        myOption.value = '';
        selectDistrict.appendChild(myOption);

    }

    selectDistrict?.addEventListener("change", (e)=>{
        selectCommuneReset();

        if(""===e.target.value) {
            return;
        }

        let xhr = new XMLHttpRequest();
        let url = urlPage.origin + "/wp-content/themes/pp/inc/pna-form/pna-search-commune.php";

        let data = new FormData();
        data.append('district',e.target.value);
        data.append('province',selectVoivodeship.value);
        xhr.open("POST", url, true);
        xhr.send(data);
        selectCommunePreloader.style.display = 'flex';


        xhr.onload = () => {
            if (xhr.status !== 200) {
                console.log(`Error ${xhr.status}: ${xhr.statusText}`);
            } else {

                let res;
                res = JSON.parse(xhr.response);
                res.forEach((item,index) => {
                    let myOption;
                    myOption = document.createElement("option");
                    myOption.text = item.name;
                    myOption.value = item.value;
                    myOption.label = item.name;
                    selectCommune.appendChild(myOption);
                });
                selectCommunePreloader.style.display = 'none';
            }
        }

        xhr.onerror = () => console.log("Request failed");


    });

    function selectCommuneReset() {
        selectCommune.value = null;

        while (selectCommune.options.length > 0) {
            selectCommune.remove(0);
        }

        let myOption;
        myOption = document.createElement("option");
        myOption.text = 'Wybierz gminę';
        myOption.value = '';
        selectCommune.appendChild(myOption);
    }

    $('input[name="city"]').autocomplete({
        source: '/wp-content/themes/pp/inc/pna-form/pna-search-city.php',
        minLength: 2,
        select: function (event, ui) {
            nextFieldUpdate('input[name="street"]', ui.item, '/wp-content/themes/pp/inc/pna-form/pna-search-street.php');
        },
        response: function (event, ui) {
            if (ui.content.length === 3) {
                event.target.addEventListener('keydown', function (e) {
                    if (e.keyCode === 9) {
                        this.value = ui.content[0].value;
                        nextFieldUpdate('input[name="street"]', ui.item, '/wp-content/themes/pp/inc/pna-form/pna-search-street.php');
                    }
                });
            }
        },
    });


    $('input[name="street"]').autocomplete({
        source: '/wp-content/themes/pp/inc/pna-form/pna-search-street.php',
        minLength: 2
    });

     $('input[name="city"]').on('change', function () {
         if (this.value.length > 0) {
             nextFieldUpdate('input[name="street"]', {
                 id: this.value,
                 value: this.value
             }, '/wp-content/themes/pp/inc/pna-form/pna-search-street.php');
         }
     });

    $('input[name="postalCode"]')
        .inputmask({
            mask: '99 - 999',
            placeholder: '',
            showMaskOnHover: false,
            showMaskOnFocus: false,
        });

    function nextFieldUpdate(fieldSelector, ui, scriptSource) {
        let fetchedData = ['Brak danych'];

        let selectedCity = new FormData();
        selectedCity.append('id', ui.id);
        selectedCity.append('value', ui.value);

        let url = new URL(document.URL);
        const pnaUrl = url.origin + scriptSource;

        let xhr = new XMLHttpRequest();
        xhr.open('POST', pnaUrl, true);
        xhr.send(selectedCity);
        xhr.onload = function () {
            fetchedData = JSON.parse(xhr.responseText);

            $(fieldSelector).autocomplete({
                source: fetchedData,
                minLength: 1
            });
        }
    }
});

